export default "__VITE_ASSET__876ea2ed__"